<template>
    <div class="flat-view">
        <amf-form :title="title" class="container">
            <div class="all-workflows container">
                <div v-if="!busy">

                    <div class="flex-row" v-if="!showUserSearch">
                        <span>{{filter}}</span>
                    </div>

                    <div class="flex-row" style="justify-content: flex-end; align-items: center">
                        <amf-button :onClick="showWorkflowStats">Statistics</amf-button>
                        <amf-button class="ml-2" :onClick="clearFilter">Mine</amf-button>
                        <amf-button class="ml-2" :onClick="()=>showUserSearch = true">Other User</amf-button>
                        <amf-button class="ml-2" :onClick="showUnassigned">No CSS</amf-button>
                    </div>

                    <div class="flex-row mt-2" v-if="showUserSearch"
                        style="justify-content: flex-end; align-items: center">
                        <user-search :showLabel="false" :onSelectUser="onSelectUser" label=""></user-search>
                        <amf-button href="#" class="ml-1" :onClick="()=>showUserSearch = false">Cancel</amf-button>
                    </div>

                    <v-client-table :data="filteredWorkflows" :columns="workflowColumns" :options="workflowOptions">
                        <template v-slot:name="{ row }">
                            <router-link :to="`/employer/${row.employerId}/general`">{{ row.name }}</router-link>
                        </template>
                        <template v-slot:actions="{ row }">
                            <div v-if="can.editWorkflowStatus">
                                <button class="btn btn-sm" id="actionItemDropDown" data-toggle="dropdown"
                                    style="border:none">
                                    <span class="fa fa-sm fa-ellipsis-v"></span>
                                </button>
                                <div class="dropdown-menu dropdown-menu-right" :aria-labelledby="'dropDown'">
                                    <div>
                                        <a href="#" class="dropdown-item" @click.prevent="undoWorkflow(row)">
                                            Undo Workflow Action Item
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-slot:actionItemPreview="{ row }">
                            <div>
                                <a @click.prevent="showActionItems(row)" href="#">
                                    <span>{{ row.actionItemPreview }}</span>
                                </a>
                            </div>
                        </template>
                    </v-client-table>

                </div>
            </div>
        </amf-form>

    </div>
</template>

<script>

import uuid from "uuid/v4";
import { modalService } from '../framework/utils/modal-service';
import UserWorkflowStatsModal from "./UserWorkflowStatsModal";
import parentViewMixin from '../framework/utils/parent-view-mixin';
import UndoWorkflowModal from "../workflow/UndoWorkflowModal";
import UserSearch from "../shared/UserSearch";

const emptyGuid = "00000000-0000-0000-0000-000000000000";

export default {
    components: { UserSearch },
    mixins: [parentViewMixin],
    routeQuery: ["userId", "actionItemType", "sDate", "eDate"],
    data() {
        return {
            showOtherEmployers: true,

            actionItemType: null,
            userId: null,
            sDate: null,
            eDate: null,
            userFullName: null,

            allWorkflows: [],
            filteredWorkflows: [],


            daysPerBucket: 5,

            workflowColumns: ["name", "workflowType", "assignmentsPreview", "actionItemPreview", "lastActionItemCreated", "lastReachoutCreated", "actions"],

            editableColumns: [],
            workflowOptions: {
                ...utils.getVueTablesOptions(),
                texts: {
                    filter: null,
                    count: ''
                },
                skin: "table table-bordered",
                headings: {
                    name: "Employer",
                    amfCode: "AMF",
                    workflowType: "Type",
                    assignmentsPreview: "Held by",
                    lastActionItemCreated: "Action Item",
                    lastReachoutCreated: "Reachout",
                    updated: "Updated",
                    actionItemPreview: "Items",
                    actions: "",
                },
            },
            representatives: null,
            amfOptions: { noTracking: true, },
            loading: false,
            showUserSearch: false
        };
    },
    computed: {
        ...amfx.map("session", "user"),
        ...amfx.map('session', 'sessionUserId:userId'),
        filter() {
            var filter = [];
            if (!this.userId) return "User not selected";
            if (this.userId === "unassigned") return "Not assigned to CSS";
            filter.push(" Owner: " + this.userFullName);
            if (this.actionItemType) filter.push(` With "${this.formatActionItemType(this.actionItemType)}"`);
            if (this.sDate) filter.push(` Updated between ${this.sDate} and ${this.eDate}`);
            if (filter.length == 0) return null;
            return filter.join(", ");
        },
        title() {
            return "Workflows";
        },
        filteredEmployers() {
            return this.allEmployers.filter(e => {
                var allText = _.values(e).join(",").toLowerCase();
                var userFullName = this.user.fullName.toLowerCase();
                if (!this.showOtherEmployers && !allText.includes(userFullName)) {
                    return false;
                }
                if (!this.searchText || allText.includes(this.searchText.toLowerCase())) return true;
            });
        }
    },
    created() {
        this.loadWorkflows();
    },
    methods: {
        ...amfx.map("actionItems", "searchActionItems:search"),
        onRouteQueryUpdate() {
            this.loadWorkflows();
        },
        async clearFilter() {
            this.showUserSearch = false;
            this.$router.push("/workflows?userId=" + this.sessionUserId);
        },
        async showWorkflowStats() {
            var data = await modalService.show("workflow-stats", UserWorkflowStatsModal, { userId: this.getUserId() });
            let id = this.sessionUserId;
            this.userId = data.userId || id;
            this.actionItemType = data.actionItemType || null;
            if (data.updatedStartDate || data.updatedEndDate) {
                this.sDate = data.updatedStartDate;
                this.eDate = data.updatedEndDate;
            } else {
                this.sDate = null;
                this.eDate = null;
            }
        },
        formatActionItemType(itemType) {
            return itemType && itemType.replace("ewf-", "").replace(/-/gi, " ");
        },
        showActionItems(e) {
            this.searchActionItems({ employerId: e.employerId });
        },
        getEmployerUrl(employer) {
            return `/employer/${employer.employerId}/general`;
        },
        async loadWorkflows() {
            if (this.loading) return;
            this.loading = true;
            setTimeout(async () => {
                if (!this.userId) {
                    this.allWorkflows = [];
                    this.filteredWorkflows = [];
                    this.loading = false;
                    return;
                }

                var request = {
                    actionItemType: this.actionItemType,
                    updatedStartDate: this.sDate,
                    updatedEndDate: this.eDate,
                };

                if (this.userId == "unassigned") {
                    request.showUnassigned = true;
                } else {
                    request.userId = this.userId;
                }

                let workflows = await romeApi.get("/workflow/status", request);

                workflows.forEach(this.extendWorkflow);
                workflows = _.orderBy(workflows, "name");

                this.allWorkflows = workflows;
                this.filteredWorkflows = workflows.map(w => w);

                this.updateFullUserName();
                this.loading = false;
            }, 100);
        },
        getWorkflowDisplayType(type) {
            return (type || "")
                    .replace("new-employer-workflow", "New")
                    .replace("renewal-workflow", "Renewal")
                    .replace("cobra-rate-workflow", "COBRA Rates")
        },
        extendWorkflow(e) {
            e.name = `${e.name} ${e.amfCode}`;
            e.workflowType = this.getWorkflowDisplayType(e.workflowType);
            e.updated = formatters.date(moment.max([moment(e.lastActionItemCreated), moment(e.lastReachoutCreated)]));
            e.lastActionItemCreated = formatters.date(e.lastActionItemCreated);
            e.lastReachoutCreated = formatters.date(e.lastReachoutCreated);
            e.actionItemPreview = _(e.actionItemTypes).take(2).map(this.formatActionItemType).value().join(", ");
            if (e.assignments) {
                e.assignmentsPreview = _(e.assignments).take(2).map(a => a.replace("employer.", "")).join(", ");
            }
            if (e.actionItemTypes.length > 2) e.actionItemPreview += "...";
            if (e.assignments && e.assignments.length > 2) e.assignmentsPreview += "...";
        },
        getUserId() {
            if (this.userId && this.userId != emptyGuid) return this.userId;
            return this.sessionUserId;
        },
        async updateFullUserName() {
            if (!this.getUserId() || this.getUserId() === "unassigned") return;
            var filterUser = await romeApi.get("/user/" + this.getUserId());
            this.userFullName = filterUser.firstName + " " + filterUser.lastName;
        },
        async undoWorkflow(workflow) {
            var data = await modalService.show("undo-workflow", UndoWorkflowModal, { employerId: workflow.employerId });
        },
        async onSelectUser(user) {
            this.userId = user.userId;
            this.showUserSearch = false;
        },
        showUnassigned() {
            this.$router.push(`/workflows?userId=unassigned`);
        }
    },
    watch: {
        sessionUserId() {
            this.updateFullUserName();
        },
        userId(newVal) {
            if (newVal === emptyGuid) {
                this.userId = null;
            } else {
                this.updateFullUserName();
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .all-workflows {
        height: 100%;
        overflow-y: auto;
        overflow-x:hidden;
    }

    .all-workflows a {
        color: black;
    }
</style>



// WEBPACK FOOTER //
// src/workflow/Workflows.vue